







// group: the side menu's section (SideMenu.vue prints a title + a line above each one but 'main',
//        in the order the entries come here - an entry joins the section of the entries around it)
// icon:  a name from menu_icons.js
// match: more paths that light this entry up (the longest route / match the current path starts with wins)
let MenuForBiz = [
   {
      name: 'dashboard',
      route: '/',
      match: ['/dashboard'],
      group: 'main',
      icon: 'house',
      service: 1
   },
   {
      name: 'calendar',
      route: '/calendar',
      group: 'manage',
      icon: 'calendar',
      service: 3
   },
   {
      name: 'customers',
      route: '/customers',
      match: ['/customer', '/customers-archive', '/customers2'],
      group: 'manage',
      icon: 'users',
      service: 2
   },
   {
      // עמדת אירוח — the reception desk (biz-services 11). The owner and the staff open it from
      // here; the desk's own login lands on it directly and has no menu at all.
      name: 'hostingStation',
      route: '/hosting-station',
      group: 'manage',
      icon: 'user-check',
      service: 11,
      requireService: true,
      permission: 'guests.arrival'
   },
   // {
   //    name: 'events',
   //    route: '/events',
   //    service: 15
   // },

   {
      name: 'tasks',
      route: '/tasks',
      group: 'manage',
      icon: 'square-check',
      service: 9999
   },
   {
      // מעקב פגישות: what came of the meetings (סטטוסי פגישות) - cancelled / no-shows, and the ones that
      // wait for a new date (meeting-tracking on the api)
      name: 'meetingsTracking',
      route: '/meetings',
      group: 'manage',
      icon: 'calendar-check',
      service: 9999
   },
   {
      // שעון נוכחות: every staff login clocks in / out here, managers get the report (time-clock
      // module). The root admin can switch the module off per account (feature 'timeClock').
      name: 'timeClock',
      route: '/time-clock',
      group: 'manage',
      icon: 'clock',
      service: 99999,
      feature: 'timeClock'
   },
   {
      // Experimental Inventory & Rentals module — visible ONLY to users holding the per-user
      // 'inventory' grant (root-admin grants the owner; the owner tags children via the users screen).
      name: 'inventory',
      route: '/inventory',
      group: 'manage',
      icon: 'package',
      service: 54344237,
      permission: 'inventory'
   }, {
      // "הפקת חשבוניות פנימית" — the root admin can switch it off per account (tenant-admin)
      name: 'accounting',
      route: '/accounting',
      match: ['/taxDocument', '/createTaxDocument'],
      group: 'finance',
      icon: 'receipt-text',
      service: 99999,
      permission: 'reports.view',
      feature: 'invoicing'
   }, {
      // תשלומים צפויים: the deals' payment schedules across events (expected-payments module)
      name: 'expectedPayments',
      route: '/expected-payments',
      group: 'finance',
      icon: 'calendar-clock',
      service: 99999,
      permission: 'reports.view'
   }, {
      // צ'קים: where every check of the receipts is, deposits, bounced checks (checks module)
      name: 'checks',
      route: '/checks',
      group: 'finance',
      icon: 'wallet',
      service: 99999,
      permission: 'reports.view',
      feature: 'invoicing'
   },
   // {
   //    name: 'billing',
   //    route: '/billing',
   //    service: 4
   // },
   //  {
   //    name: 'analytics',
   //    route: '/reports',
   //    service: 5
   // },
   {
      name: 'reports',
      group: 'finance',
      icon: 'chart-column',
      service: 54344235,
      permission: 'reports.view',
      subMenu: [
         {
            name: 'reportsGeneral',
            service: 54344235,
            route: '/reports',
            permission: 'reports.view'
         },
         {
            name: 'advancedAnalytics',
            service: 54344235,
            route: '/reports/pivot',
            permission: 'reports.view'
         },
         {
            // דוח תזרים: expected payments + checks + income + expenses by month
            name: 'cashflow',
            service: 54344235,
            route: '/reports/cashflow',
            permission: 'reports.view'
         }
      ]
   },
   {
      name: 'expenses',
      route: '/expenses',
      group: 'finance',
      icon: 'wallet',
      service: 54344236,
      permission: 'expenses.view'
   },
   {
      name: 'messages',
      route: '/messages',
      group: 'communication',
      icon: 'mail',
      service: 54344234
   },
   {
      // Online booking — visible only for accounts the SYSTEM admin enabled the service for
      // (biz-services id 10, toggled in the root-admin UserServices screen). Sits right above
      // הגדרות at the owner's request (2026-09-30).
      name: 'bookingRequests',
      route: '/booking-requests',
      group: 'communication',
      icon: 'calendar-clock',
      service: 10,
      requireService: true,
      permission: 'calendar.view'
   },
   {
      name: 'settings',
      group: 'system',
      icon: 'settings',
      service: 8,
      // Every item here is a per-user privilege: business-settings pages need settings.view
      // (the "business settings" toggle / admin), the users page needs users.index (owner or
      // admin user). The group auto-hides when no item is visible (SideMenu filters subMenus).
      subMenu: [
         {
            name: 'orginizationSettings',
            service: 9,
            route: '/settings',
            permission: 'settings.view'
         },
         {
            name: 'homepageSettings',
            service: 9,
            route: '/settings/homepage',
            permission: 'settings.view'
         },
         {
            // איחוד לקוחות כפולים: find cards sharing a phone / email / name and fold them into one
            name: 'duplicateCustomers',
            service: 9,
            route: '/settings/duplicates',
            permission: 'settings.view'
         },
         {
            name: 'bookingSettings',
            service: 10,
            requireService: true,
            route: '/settings/booking',
            permission: 'settings.view'
         },
         {
            // the venue suite: floor plans, sketches, the RSVP finalize deadline — any of 11–15 on
            name: 'venueSettings',
            service: [11, 12, 13, 14, 15],
            requireService: true,
            route: '/settings/venue',
            permission: 'settings.view'
         },
         {
            // טופס הפקה (biz-services 17): the questionnaire's template (sections, questions, the
            // texts the couple sees, the auto-lock) — configuration, so it sits with the settings
            name: 'productionFormSettings',
            service: 17,
            requireService: true,
            route: '/settings/production-form',
            permission: 'settings.view'
         },
         {
            // לוח תשלומים: the schedule templates, auto-spread on signing, the whatsapp reminder
            name: 'paymentScheduleSettings',
            service: 4545331,
            route: '/settings/payment-schedule',
            permission: 'settings.view'
         },
         {
            // שעון נוכחות: the regular day, overtime, the automatic break, the forgotten-shift limit
            name: 'timeClockSettings',
            service: 4545332,
            route: '/settings/time-clock',
            permission: 'settings.view',
            feature: 'timeClock'
         },
         {
            // לידים במייל (biz-services 16): a mailbox per lead source, fields marked on a sample
            // mail. It is configuration, so it sits with the settings and takes their privilege.
            name: 'emailLeads',
            service: 16,
            requireService: true,
            route: '/email-leads',
            permission: 'settings.view'
         },
         {
            name: 'users',
            route: '/users',
            service: 9998,
            permission: 'users.index'
         },
         {
            name: 'milestones',
            service: 4545329,
            route: '/milestones',
            permission: 'settings.view'
         },


         {
            name: 'automations',
            service: 3333,
            route: '/automations',
            match: ['/editAutomation'],
            permission: 'settings.view'
         },

         {
            name: 'messageTemplates',
            service: 3332,
            route: '/messageTemplates',
            permission: 'settings.view'
         },


         {
            name: 'documents',
            service: 11,
            route: '/documents',
            match: ['/document'],
            permission: 'settings.view'
         },
         {
            name: 'parametersSettings',
            service: 10,
            route: '/parameters',
            permission: 'settings.view'
         },
         {
            name: 'customFields',
            service: 10,
            route: '/custom-fields',
            permission: 'settings.view'
         },
         {
            name: 'itemGroups',
            route: '/itemgroups',
            service: 3334,
            permission: 'settings.view'
         },
         {
            name: 'foodMenu',
            route: '/food-menu',
            service: 3335,
            permission: 'settings.view'
         },
         {
            // its own module - shown only when the system admin switched biz-service 19 on
            name: 'barMenu',
            route: '/bar-menu',
            service: 19,
            requireService: true,
            permission: 'settings.view'
         }


      ]
   },
   {
      name: 'log',
      route: '/log',
      group: 'system',
      icon: 'history',
      service: 1337
   }


];





export default MenuForBiz;